<template>
  <div class="p-information">
    <v-img src="/images/banner/information-new.png" :height="bannerHeight">
      <v-layout
        fill-height
        align-center
        justify-center
        column
        class="light-text"
      >
        <h1>易才宏业保险经纪有限公司</h1>
        <h2 class="mt-4">互联网保险信息披露</h2>
      </v-layout>
    </v-img>
    <div class="section">
      <v-tabs class="navigation" centered center-active v-model="chooseId">
        <v-tab
          v-for="(item, index) in navigationList"
          :key="index"
          @click="choose(index)"
          class="item_tab"
          :class="chooseId === index ? 'pitchLi' : ''"
          >{{ item }}</v-tab
        >
      </v-tabs>
    </div>

    <div v-show="chooseId === 0">
      <section class="section">
        <h2 class="mb-4">公司经营资质</h2>
        <v-layout justify-center wrap>
          <v-flex xs12 sm12 md6>
            <v-img
              max-height="400px"
              contain
              src="https://insurance-bs.wanhuahengxin.com/%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE/new-insurance-licence-1.jpg"
            ></v-img>
          </v-flex>
          <v-flex xs12 sm12 md6>
            <v-img
              max-height="400px"
              contain
              src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/new-business-license.png"
            ></v-img>
          </v-flex>
        </v-layout>
      </section>
      <section class="section">
        <h2 class="mb-4">互联网保险自营平台信息</h2>
        <!-- <v-data-table
          :headers="supportHeaders"
          :items="supportItems"
          hide-actions
          class="table"
        > -->
        <v-data-table
          :items="supportItems"
          hide-actions
          class="table"
        >
          <template slot="items" slot-scope="props">
            <td class="td-text">{{ props.item.name }}</td>
            <td class="td-text">{{ props.item.company }}</td>
          </template>
        </v-data-table>
      </section>
      <section class="section">
        <h2 class="mb-4">各地分公司联系方式</h2>
        <v-data-table
          :headers="informationHeaders"
          :items="informationItems"
          hide-actions
          class="table"
        >
          <template slot="items" slot-scope="props">
            <td class="td-text">{{ props.item.name }}</td>
            <td class="td-text">{{ props.item.company }}</td>
            <td class="td-text tb-row-caption">
              <div
                v-if="typeof props.item.no === 'string'"
                v-html="props.item.no"
              ></div>
              <div v-else>
                <div v-for="item in props.item.no" :key="item">{{ item }}</div>
              </div>
            </td>
          </template>
        </v-data-table>
      </section>

      <section class="section">
        <h2 class="mb-4">客户告知书</h2>
        <div class="contact">
          <v-img src="/images/information/khgzs4.png" contain></v-img>
        </div>
      </section>

      <section class="section">
        <h2 class="mb-4">信息安全</h2>
        <div class="contact">
          <p class="contact-email">
            针对消费者的个人信息、投保交易信息和交易安全，已进行加密传输，严保传输过程中信息不被泄露。并开启安全管理系统权限设置，防止资料被无权限获取
          </p>
        </div>
      </section>

      <section class="section">
        <h2 class="mb-4">从业人员执业登记信息查询</h2>
        <div class="contact">
          <p>
            <a
              href="https://www.insurcloud.com.cn/model/zxgg/index/"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.insurcloud.com.cn/model/zxgg/index/</a
            >
          </p>
        </div>
      </section>

      <section class="section">
        <h2 class="mb-4">客户服务及投诉渠道</h2>
        <div class="contact">
          <p>投保、理赔、保全服务及投诉电话：4006-234-345</p>
          <p class="contact-email">联系邮箱：ycbxjj@chinatalentgroup.com</p>
          <!-- <v-img
            max-height="200px"
            contain
            src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/kfwx.png"
          ></v-img> -->
        </div>
      </section>
    </div>

    <div v-show="chooseId === 1">
      <section class="section b_section">
        <h2 class="mb-4">当前互联网保险产品信息详情</h2>
        <v-data-table
          dense
          :headers="headers"
          :items="itemsNew"
          hide-actions
          class="table"
        >
          <template slot="items" slot-scope="props">
            <td 
              v-if="companyRowspanMap[props.item.name].firstIndex === props.index" 
              :rowspan="companyRowspanMap[props.item.name].count" 
              class="td-text"
            >{{ props.item.name }}</td>
            <td 
              v-if="titleRowspanMap[`${props.item.name}-${props.item.title}`].firstIndex === props.index" 
              :rowspan="titleRowspanMap[`${props.item.name}-${props.item.title}`].count" 
              class="td-text"
            >{{ props.item.title }}</td>
            <td class="td-text">{{ props.item.no }}</td>
            <td class="td-text">
              <div>
                <div v-for="item in props.item.serial_num" :key="item">
                  {{ item }}
                </div>
              </div>
            </td>
            <td class="td-text">{{ decodeURIComponent(props.item.terms) }}</td>
            <td class="td-text">{{ props.item.link }}</td>
          </template>
        </v-data-table>
      </section>
    </div>
    <div v-show="chooseId === 2">
      <section class="section b_section">
        <h2 class="mb-4">合作保险公司</h2>
        <v-data-table
          dense
          :headers="productHeaders"
          :items="productItems"
          hide-actions
          class="table"
        >
          <template slot="items" slot-scope="props">
            <td class="td-text">{{ props.item.name }}</td>
            <td class="td-text">{{ props.item.branch }}</td>

            <td class="td-text tb-row-caption">
              {{ props.item.no }}
            </td>
            <td class="td-text tb-row-caption">
              {{ props.item.time }}
            </td>
            <td class="td-text">
              <a :href="props.item.company" target="_blank">{{
                props.item.company
              }}</a>
            </td>
            <td class="td-text">{{ props.item.tel }}</td>
            <td class="td-text">{{ props.item.flow }}</td>
            <td class="td-text">
              <a :href="props.item.evaluate" target="_blank">{{
                props.item.evaluate
              }}</a>
            </td>
          </template>
        </v-data-table>
      </section>
    </div>
    <div v-show="chooseId === 3">
      <PrivacyContent />
    </div>
    <div v-show="chooseId === 4">
      <section class="section" v-if="showId == 0">
        <div v-for="item in list" :key='item.id'>
          <div @click="showId = item.id" style="cursor: pointer; margin-bottom: 20px;border-bottom: 1px solid #eee; padding-bottom: 18px;">
            {{ item.label }} <span style="float: right;">{{ item.time }}</span>
          </div>
        </div>
      </section>
      <qingshuizb v-if="showId == 1004"/>
      <hlwyxxcsqgzs v-if="showId == 1008"/>
    </div>
  </div>
</template>

<script>
import PrivacyContent from "./other/PrivacyContent";
import qingshuizb from "./announcement/components/1004"
import hlwyxxcsqgzs from "./announcement/components/1008"
export default {
  components: {
    PrivacyContent,
    qingshuizb,
    hlwyxxcsqgzs
  },
  metaInfo: {
    title: "信息披露",
  },
  data() {
    return {
      loading: false,
      supportHeaders: [
        { text: "", value: "name", sortable: false },
        { text: "", value: "company", sortable: false },
      ],
      chooseId: 0,
      showId: 0,
      navigationList: [
        "经营资质页",
        "保险产品信息披露页",
        "合作保险公司及机构披露页",
        "隐私政策",
        "消费者权益保护"
      ],
      list:[
        {
          id:1008,
          label:'关于防范保险从业人员违规销售非保险金融产品的风险提示',
          time: '2026-01-15',
        },
        {
          id:1004,
          label:'关于防范新型电信网络诈骗的风险提示',
          time: '2026-01-15',
        },
      ],
      supportItems: [
        {
          name: "披露机构全称",
          company: "易才宏业保险经纪有限公司",
        },
        {
          name: "披露机构简称",
          company: "易才保险经纪",
        },
        {
          name: "经营互联网保险业务的网站名称",
          company: "易才保险经纪",
        },
        {
          name: "经营互联网保险业务的网站地址",
          company: "https://www.yicaibaoxian.com/information",
        },
        {
          name: "经营互联网保险业务的APP名称",
          company: "企惠保",
        },
        {
          name: "经营互联网保险业务的微信公众号名称",
          company: "企惠保；集光易保",
        },
        {
          name: "客户服务及消费者投诉电话",
          company: "4006-234-345",
        },
        {
          name: "机构信息披露网站地址",
          company: "https://www.yicaibaoxian.com/information",
        },
        {
          name: "在中国保险行业协会官网的信息披露访问链接",
          company: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
      ],
      informationHeaders: [
        { text: "名称", value: "name", sortable: false },
        { text: "电话", value: "company", sortable: false },
        { text: "地址", value: "no", sortable: false },
      ],
      informationItems: [
        {
          name: "易才宏业保险经纪有限公司",
          company: "022-88325599",
          no: "天津市河西区黑牛城道与洞庭路交口东南侧五福大厦-1-1407、-1-1408",
        },
        {
          name: "易才宏业保险经纪有限公司北京分公司",
          company: "010-50947006",
          no: "北京市朝阳区康家沟145号一层A111",
        },
        {
          name: "易才宏业保险经纪有限公司陕西分公司",
          company: "029-81331938",
          no: "陕西省西安市碑林区长安北路113号永宁国际1号楼912室",
        },
        // {
        //   name: "易才宏业保险经纪有限公司新疆分公司",
        //   company: "0991-8822023",
        //   no: "新疆乌鲁木齐市天山区人民路33号瑞达大厦1栋9层5号"
        // },
        // {
        //   name: "易才宏业保险经纪有限公司甘肃分公司",
        //   company: "0931-8187101",
        //   no: "甘肃省兰州市城关区闵家桥100号一楼049室"
        // },
        {
          name: "易才宏业保险经纪有限公司河北分公司",
          company: "0311-82623390",
          no: "河北省石家庄市新华区中山西路83号东方大厦1202室",
        },
      ],
      // headers: [
      //   { text: "产品名称", value: "name", sortable: false },
      //   { text: "备案产品名称", value: "no", sortable: false },
      //   { text: "备案编号", value: "serial_num", sortable: false },
      //   { text: "产品条款", value: "terms", sortable: false },
      // ],
      headers: [
        { text: "保险公司名称", value: "name", sortable: false },
        { text: "实际销售名称", value: "title", sortable: false },
        { text: "备案产品名称", value: "no", sortable: false },
        { text: "批复文号/备案号/产品注册号", value: "serial_num", sortable: false },
        { text: "产品条款", value: "terms", sortable: false },
        { text: "中国保险行业协会官网网站信息披露访问链接", value: "link", sortable: false },
      ],
      items: [
        {
          name: "建设工程投标保证保险",
          company: [
            "投标履约保证保险B款条款（2019版）",
            // "富德财产保险股份有限公司建设工程投标保证保险条款",
            "华农财产保险股份有限公司建设工程施工合同投标保证保险条款",
            "天安财产保险股份有限公司建设工程投标保证保险条款",
          ],
          serial_num: [
            "C00009331412019020120642",
            // "C00016331412017081104371",
            "C00010131412019121304461",
            "C00002231412017062100681",
          ],
          terms: [
            // {
            //   "name": "投标履约保证保险B款条款（2019版）",
            //   "url": "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jsgctbx/1.pdf"
            // },
            {
              name: "阳光财产保险股份有限公司建设工程投标保证保险条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jsgctbx/2.pdf",
            },
            {
              name: "华农财产保险股份有限公司建设工程施工合同投标保证保险条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jsgctbx/3.pdf",
            },
            {
              name: "天安财产保险股份有限公司建设工程投标保证保险条款",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jsgctbx/%E5%A4%A9%E5%AE%89%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E5%BB%BA%E8%AE%BE%E5%B7%A5%E7%A8%8B%E6%8A%95%E6%A0%87%E4%BF%9D%E8%AF%81%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.docx",
            },
          ],
        },
        {
          name: "投标保证保险",
          company: ["(国寿财险)(备-保证保险)[2022](主)037号"],
          serial_num: ["2022042421522623"],
          terms: [
            {
              name: "投标保证保险条款",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/tbbz/%E6%8A%95%E6%A0%87%E4%BF%9D%E8%AF%81%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.docx",
            },
          ],
        },
        {
          name: "辽宁省公共资源交易网投标保证项目",
          company: ["投标保证保险（2016版）"],
          serial_num: [
            "中国太平洋财产保险股份有限公司投标保证保险 (2016版) 条款",
            "C00001431412016121300822",
          ],
          terms: [
            {
              name: "投标保证保险（2016版）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/lntb/1.pdf",
            },
          ],
        },
        {
          name: "建设工程施工合同履约保证保险",
          company: [
            "华农财产保险股份有限公司建设工程施工合同履约保证保险条款（2017版）",
          ],
          serial_num: ["（华农财险）（审－保证）〔2018〕（主）"],
          terms: [
            {
              name: "华农财产保险股份有限公司建设工程施工合同履约保证保险条款（2017版）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/sglybzx/1.pdf",
            },
          ],
        },
        {
          name: "集光意外保险（互联网专属）",
          company: [
            "中国平安财产保险股份有限公司平安产险意外伤害保险（互联网版）条款",
          ],
          serial_num: ["C00001732312021120910153"],
          terms: [
            {
              name: "中国平安财产保险股份有限公司平安产险意外伤害保险（互联网版）条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/1.pdf",
            },
          ],
        },
        {
          name: "集装箱货物进出口运输保险",
          company: [
            "海洋运输货物保险条款（2009版）",
            "协会货物条款 (A) 1/1/2009",
            "协会货物条款（C）-1/1/09",
            "协会船级条款（01/01/2001）",
            "制裁限制和除外条款",
            "水险计算机网络攻击除外条款",
            "传染病除外条款",
            "协会战争险条款 (货物) 1/1/09；协会罢工条款(货物)",
            "协会战争取消条款（货运）",
          ],
          serial_num: [
            "华泰(备案)[2009]N201号",
            "09IE2016000210014",
            "09IE2016000210016",
            "09AD2019000210070",
            "华泰财险（备-货运）[2012](附)157号",
            "09AD2021000210267",
            "09AD2021000210272",
            "09AD2021000210265",
            "09AD2021000210266",
            "09AD2019000210074",
          ],
          terms: [
            {
              name: "海洋运输货物保险条款（2009版）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/h1.pdf",
            },
            {
              name: "协会货物条款 (A) 1/1/2009",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/h2.pdf",
            },
            {
              name: "协会货物条款（C）-1/1/09",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/h3.pdf",
            },
            {
              name: "协会船级条款（01/01/2001）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/h4.pdf",
            },
            {
              name: "制裁限制和除外条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/h5.pdf",
            },
            {
              name: "水险计算机网络攻击除外条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/h6.pdf",
            },
            {
              name: "传染病除外条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/h7.pdf",
            },
            {
              name: "协会战争险条款 (货物)",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/h8.pdf",
            },
            {
              name: "协会罢工条款(货物)",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/h9.pdf",
            },
            {
              name: "协会战争取消条款（货运）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/h10.pdf",
            },
          ],
        },
        {
          name: "集装箱货物进出口运输保险",
          company: [
            "协会货物条款（A） 1/1/82",
            "协会船级条款 1/1/01",
            "协会战争险条款（货物）1/1/82",
            "协会罢工险条款（货物）1/1/82",
            "通知取消保单条款 （30天）",
            "协会重置条款",
            "装、卸责任条款",
            "仓至仓条款",
            "运输终止条款（恐怖行为）",
            "协会放射性污染、化学、生物、生物化学及电磁武器除外责任条款",
            "协会电脑攻击除外条款LMA5403",
            "制裁限制与除外条款",
            "货物不明原因失踪风险除外条款",
            "无人看管车辆除外责任条款",
            "协会传染病除外条款LMA5396",
          ],
          serial_num: [
            "09IE2019000230367",
            "09AD2015000230027",
            "09AD2019000230379",
            "09AD2019000230384",
            "09AD2019000230416",
            "09AD2016000230299",
            "09AD2019000230318",
            "09AD2015000230144",
            "09AD2019000230418",
            "09AD2019000230442",
            "09AD2019000230414",
            "09AD2020000230538",
            "09AD2015000230265",
            "09AD2020000230651",
          ],
          terms: [
            {
              name: "协会货物条款（A） 1/1/82",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j1.pdf",
            },
            {
              name: "协会船级条款 1/1/01",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j2.pdf",
            },
            {
              name: "协会战争险条款（货物）1/1/82",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j3.pdf",
            },
            {
              name: "协会罢工险条款（货物）1/1/82",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j4.pdf",
            },
            {
              name: "通知取消保单条款 （30天）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j5.pdf",
            },
            {
              name: "协会重置条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j6.pdf",
            },
            {
              name: "装、卸责任条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j7.pdf",
            },
            {
              name: "仓至仓条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j8.pdf",
            },
            {
              name: "运输终止条款（恐怖行为）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j9.pdf",
            },
            {
              name: "协会放射性污染、化学、生物、生物化学及电磁武器除外责任条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j10.pdf",
            },
            {
              name: "协会电脑攻击除外条款LMA5403",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j11.pdf",
            },
            {
              name: "制裁限制与除外条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j12.pdf",
            },
            {
              name: "货物不明原因失踪风险除外条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j13.pdf",
            },
            {
              name: "无人看管车辆除外责任条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j14.pdf",
            },
            {
              name: "协会传染病除外条款LMA5396",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/jgyw/j15.pdf",
            },
          ],
        },
        {
          name: "和顺保互联网团体意外伤害保险",
          company: [
            "美亚团体意外伤害保险（2021年第一版）（互联网专属）",
            "美亚附加意外医药补偿团体医疗保险（2021年第五版）（互联网专属）",
            "美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）",
            "美亚附加特种作业限制条款（2021年第二版）（互联网专属）",
            "美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）",
            "美亚附加经济制裁责任免除条款",
            "美亚附加不承保特定医院条款（2021年第二版）",
            "美亚附加每一意外事故总赔偿限额条款（2021年第一版）（互联网专属）",
            "美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）",
          ],
          serial_num: [
            "C00003932312021121719483",
            "C00003932522021122436913",
            "C00003931922021072908971",
            "C00003932322021122437203",
            "C00003932322021122437123",
            "C00003931922019052907382",
            "C00003931922021072908951",
            "C00003932322021122437463",
            "C00003932322021122437063",
          ],
          terms: [
            {
              name: "美亚团体意外伤害保险（2021年第一版）（互联网专属）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hsb/1.pdf",
            },
            {
              name: "美亚附加意外医药补偿团体医疗保险（2021年第五版）（互联网专属）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hsb/2.pdf",
            },
            {
              name: "美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hsb/3.pdf",
            },
            {
              name: "美亚附加特种作业限制条款（2021年第二版）（互联网专属）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hsb/4.pdf",
            },
            {
              name: "美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hsb/5.pdf",
            },
            {
              name: "美亚附加经济制裁责任免除条款",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hsb/6.pdf",
            },
            {
              name: "美亚附加不承保特定医院条款（2021年第二版）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hsb/7.pdf",
            },
            {
              name: "美亚附加每一意外事故总赔偿限额条款（2021年第一版）（互联网专属）",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/hsb/8.pdf",
            },
            {
              name: "美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/aig/aigInsure/%E7%BE%8E%E4%BA%9A%E9%99%84%E5%8A%A0%E4%BB%85%E6%89%BF%E4%BF%9D%E5%A2%83%E5%86%85%E6%84%8F%E5%A4%96%E4%BA%8B%E6%95%85%E6%9D%A1%E6%AC%BE%EF%BC%882021%E5%B9%B4%E7%AC%AC%E4%BA%8C%E7%89%88%EF%BC%89%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E4%B8%93%E5%B1%9E%EF%BC%89.pdf",
            },
          ],
        },
        {
          name: "易销保",
          company: [
            "财产综合险-现代保险（备案）[2009]N3号",
            "现代财产保险（中国）有限公司公众责任保险",
            "商业楼宇财产基本险自动喷淋系统水损扩展条款-现代财产（备案）[2010]附1617号",
            "商业楼宇财产一切险盗窃、抢劫扩展条款-现代财产（备案）[2010]附1566号",
            "商业楼宇财产一切险灭火费用扩展条款A-现代财产（备案）[2010]附1594号",
            "商业楼宇财产综合险清理残骸费用扩展条款-现代财产（备案）[2010]附1601号",
            "现代财产保险（中国）有限公司附加传染病营业中断保险",
            "现代财产保险（中国）有限公司附加租金费用保险",
            "交叉责任条款-现代保险（备案）[2009]N32号",
            "急救费用条款-现代保险（备案）[2009]N32号",
            "罢工、暴动、民众骚乱条款-现代保险（备案）[2009]N4号",
            "现代财产保险（中国）有限公司公众责任保险附加错误与遗漏保险",
          ],
          serial_num: [
            "H00011130612017033095271",
            "C00011130912021060378042",
            "H00011130622017040154841",
            "H00011130622017040157331",
            "H00011130622017040157611",
            "H00011130622017040156181",
            "C00011130622021033032361",
            "C00011130622021042648622",
            "H00011130922017033099881",
            "H00011130922017033000011",
            "H00011130622017033095861",
            "C00011130922021123061213",
          ],
          terms: [
            {
              name: "财产综合险-现代保险（备案）[2009]N3号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130612017033095271.pdf",
            },
            {
              name: "现代财产保险（中国）有限公司公众责任保险",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/C00011130912021060378042.pdf",
            },
            {
              name: "商业楼宇财产基本险自动喷淋系统水损扩展条款-现代财产（备案）[2010]附1617号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017040154841.pdf",
            },
            {
              name: "商业楼宇财产一切险盗窃、抢劫扩展条款-现代财产（备案）[2010]附1566号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017040157331.pdf",
            },
            {
              name: "商业楼宇财产一切险灭火费用扩展条款A-现代财产（备案）[2010]附1594号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017040157611.pdf",
            },
            {
              name: "商业楼宇财产综合险清理残骸费用扩展条款-现代财产（备案）[2010]附1601号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017040156181.pdf",
            },
            {
              name: "现代财产保险（中国）有限公司附加传染病营业中断保险",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/C00011130622021033032361.pdf",
            },
            {
              name: "现代财产保险（中国）有限公司附加传染病营业中断保险",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/C00011130622021042648622.pdf",
            },
            {
              name: "交叉责任条款-现代保险（备案）[2009]N32号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130922017033099881.pdf",
            },
            {
              name: "急救费用条款-现代保险（备案）[2009]N32号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130922017033000011.pdf",
            },
            {
              name: "便携式设备扩展条款-现代保险（备案）[2009]N4号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017033095861.pdf",
            },
            {
              name: "现代财产保险（中国）有限公司公众责任保险附加错误与遗漏保险",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/C00011130922021123061213.pdf",
            },
          ],
        },
        {
          name: "易微保",
          company: [
            "财产综合险-现代保险（备案）[2009]N3号",
            "现代财产保险（中国）有限公司公众责任保险",
            "现金保险-现代保险（备案）[2009]N29号",
            "商业楼宇财产基本险自动喷淋系统水损扩展条款-现代财产（备案）[2010]附1617号",
            "商业楼宇财产综合险供应中断扩展条款A-现代财产（备案）[2010]附1575号",
            "烟熏扩展条款-现代保险（备案）[2009]N4号",
            "水暖管爆裂保险条款-现代保险（备案）[2009]N4号",
            "商业楼宇财产一切险盗窃、抢劫扩展条款-现代财产（备案）[2010]附1566号",
            "商业楼宇财产一切险灭火费用扩展条款A-现代财产（备案）[2010]附1594号",
            "商业楼宇财产综合险清理残骸费用扩展条款-现代财产（备案）[2010]附1601号",
            "现代财产保险（中国）有限公司附加传染病营业中断保险",
            "现代财产保险（中国）有限公司附加租金费用保险",
            "交叉责任条款-现代保险（备案）[2009]N32号",
            "广告及装饰装置责任条款-现代保险（备案）[2009]N32号",
            "急救费用条款-现代保险（备案）[2009]N32号",
            "罢工、暴动、民众骚乱条款-现代保险（备案）[2009]N4号",
            "现代财产保险（中国）有限公司公众责任保险附加错误与遗漏保险",
          ],
          serial_num: [
            "H00011130612017033095271",
            "C00011130912021060378042",
            "H00011130612017033099751",
            "H00011130622017040154841",
            "H00011130622017040155921",
            "H00011130622017033095721",
            "H00011130622017033095291",
            "H00011130622017040157331",
            "H00011130622017040157611",
            "H00011130622017040156181",
            "C00011130622021033032361",
            "C00011130622021042648622",
            "H00011130922017033099881",
            "H00011130922017033000031",
            "H00011130922017033000011",
            "H00011130622017033095441",
            "C00011130922021123061213",
          ],
          terms: [
            {
              name: "财产综合险-现代保险（备案）[2009]N3号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130612017033095271.pdf",
            },
            {
              name: "现代财产保险（中国）有限公司公众责任保险",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/C00011130912021060378042.pdf",
            },
            {
              name: "现金保险-现代保险（备案）[2009]N29号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130612017033099751.pdf",
            },
            {
              name: "商业楼宇财产基本险自动喷淋系统水损扩展条款-现代财产（备案）[2010]附1617号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017040154841.pdf",
            },
            {
              name: "商业楼宇财产综合险供应中断扩展条款A-现代财产（备案）[2010]附1575号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017040155921.pdf",
            },
            {
              name: "烟熏扩展条款-现代保险（备案）[2009]N4号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017033095721.pdf",
            },
            {
              name: "水暖管爆裂保险条款-现代保险（备案）[2009]N4号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017033095291.pdf",
            },
            {
              name: "商业楼宇财产一切险盗窃、抢劫扩展条款-现代财产（备案）[2010]附1566号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017040157331.pdf",
            },
            {
              name: "商业楼宇财产一切险灭火费用扩展条款A-现代财产（备案）[2010]附1594号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017040157611.pdf",
            },
            {
              name: "商业楼宇财产综合险清理残骸费用扩展条款-现代财产（备案）[2010]附1601号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017040156181.pdf",
            },
            {
              name: "现代财产保险（中国）有限公司附加传染病营业中断保险",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/C00011130622021033032361.pdf",
            },
            {
              name: "现代财产保险（中国）有限公司附加租金费用保险",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/C00011130622021042648622.pdf",
            },
            {
              name: "交叉责任条款-现代保险（备案）[2009]N32号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130922017033099881.pdf",
            },
            {
              name: "广告及装饰装置责任条款-现代保险（备案）[2009]N32号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130922017033000031.pdf",
            },
            {
              name: "急救费用条款-现代保险（备案）[2009]N32号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130922017033000011.pdf",
            },
            {
              name: "罢工、暴动、民众骚乱条款-现代保险（备案）[2009]N4号",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/H00011130622017033095441.pdf",
            },
            {
              name: "现代财产保险（中国）有限公司公众责任保险附加错误与遗漏保险",
              url: "https://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/ywb/C00011130922021123061213.pdf",
            },
          ],
        },
        {
          name: "易才工意保雇主责任险",
          company: ["易才工意保雇主责任险"],
          serial_num: ["C00019930912021063099052"],
          terms: [
            {
              name: "泰康在线财产保险股份有限公司雇主责任保险(B款)条款",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/gybgzzr/8.%E9%9B%87%E4%B8%BB%E8%B4%A3%E4%BB%BB%E4%BF%9D%E9%99%A9(B%E6%AC%BE)%E6%9D%A1%E6%AC%BE.docx",
            },
          ],
        },
        {
          name: "尊享e生2021慢病版",
          company: [
            "个人住院医疗保险（互联网2022版E款）",
            "附加恶性肿瘤质子重离子医疗保险（互联网2022版A款）",
            "附加恶性肿瘤特定药械费用医疗保险（互联网2022版A款）",
          ],
          serial_num: [
            "C00017932512022021610051",
            "C00017932522021111900133,(众安在线)(备-医疗保险)【2021】(附) 172号",
            "C00017932522021111900153,(众安在线)(备-医疗保险)【2021】(附) 143号",
          ],
          terms: [
            {
              name: "个人住院医疗保险（互联网2022版E款）",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/2021mxb/%E4%BC%97%E5%AE%89%E5%9C%A8%E7%BA%BF%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E4%B8%AA%E4%BA%BA%E4%BD%8F%E9%99%A2%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%912022%E7%89%88E%E6%AC%BE%EF%BC%89.pdf",
            },
            {
              name: "附加恶性肿瘤质子重离子医疗保险（互联网2022版A款）",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/2021mxb/2.12.2-%E4%BC%97%E5%AE%89%E5%9C%A8%E7%BA%BF%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%99%84%E5%8A%A0%E6%81%B6%E6%80%A7%E8%82%BF%E7%98%A4%E8%B4%A8%E5%AD%90%E9%87%8D%E7%A6%BB%E5%AD%90%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%912022%E7%89%88A%E6%AC%BE%EF%BC%89.docx",
            },
            {
              name: "附加恶性肿瘤特定药械费用医疗保险（互联网2022版A款）",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/2021mxb/2.12.3-%E4%BC%97%E5%AE%89%E5%9C%A8%E7%BA%BF%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%99%84%E5%8A%A0%E6%81%B6%E6%80%A7%E8%82%BF%E7%98%A4%E7%89%B9%E5%AE%9A%E8%8D%AF%E6%A2%B0%E8%B4%B9%E7%94%A8%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%912022%E7%89%88A%E6%AC%BE%EF%BC%89.docx",
            },
          ],
        },
        {
          name: "国任集光保障计划（互联网）",
          company: [
            "国任财产保险股份有限公司个人意外伤害保险（互联网专属2022版）",
            "国任财产保险股份有限公司附加个人意外伤害医疗保险（互联网专属）",
            "国任财产保险股份有限公司附加交通工具意外伤害保险（互联网专属2022版）",
            "国任财产保险股份有限公司附加救护车车费保险（互联网专属）",
          ],
          serial_num: [
            "C00014232312022062811631",
            "C00014232522021121625773",
            "C00014232322022062811861",
            "C00014232522021122130853",
          ],
          terms: [
            {
              name: "国任财产保险股份有限公司个人意外伤害保险（互联网专属2022版）",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/grbx/%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.pdf",
            },
            {
              name: "国任财产保险股份有限公司附加个人意外伤害医疗保险（互联网专属）",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/grbx/%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.pdf",
            },
            {
              name: "国任财产保险股份有限公司附加交通工具意外伤害保险（互联网专属2022版）",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/grbx/%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.pdf",
            },
            {
              name: "国任财产保险股份有限公司附加救护车车费保险（互联网专属）",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/grbx/%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.pdf",
            },
          ],
        },
        {
          name: "用药无忧特药险",
          company: [
            "国任财产保险股份有限公司恶性肿瘤特定药品医疗保险（互联网专属）",
          ],
          serial_num: ["C00014232512021121626093"],
          terms: [
            {
              name: "国任财产保险股份有限公司恶性肿瘤特定药品医疗保险（互联网专属）条款",
              url: "http://qihuibao.oss-cn-beijing.aliyuncs.com/tiaokuan/grbx/%E5%9B%BD%E4%BB%BB%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E6%81%B6%E6%80%A7%E8%82%BF%E7%98%A4%E7%89%B9%E5%AE%9A%E8%8D%AF%E5%93%81%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E4%B8%93%E5%B1%9E%EF%BC%89%E6%9D%A1%E6%AC%BE.pdf",
            },
          ],
        },
      ],
      productHeaders: [
        { text: "公司名称", value: "name", sortable: false },
        { text: "分支机构", value: "branch", sortable: false },
        { text: "业务合作范围", value: "no", sortable: false },
        { text: "合作起止时间", value: "time", sortable: false },
        { text: "公司网址", value: "company", sortable: false },
        { text: "客服电话", value: "tel", sortable: false },
        {
          text: "产品及保单的查询和验真途经/理赔争议处理机制和工作流程",
          value: "flow",
          sortable: false,
        },
        {
          text: "一年来综合偿付能力充足率/风险综合评级/消费者权益保护监督评价",
          value: "evaluate",
          sortable: false,
        },
      ],
      productItems: [
        {
          name: "众安在线财产保险股份有限公司",
          branch:
            "在中华人民共和国境内（港、澳、台地区除外）开展与互联网交易直接相关的保险业务，不设分支机构",
          time: "2026/08/01-2029/7/31",
          flow: "保险公司官网",
          tel: "952299",
          evaluate:
            "https://www.zhongan.com/channel/public/publicInfo2018.html		",
          no: "易才宏业保险经纪有限公司在保险公司的授权下，严格依据《保险中介许可证》的业务范围为客户提供保险经纪服务的同时代理销售保险公司授权的保险产品",
          company: "https://www.zhongan.com/",
        },
        {
          name: "中国平安财产保险股份有限公司",
          branch:
            "北京市、天津市、河北省、山西省、内蒙古自治区、辽宁省、吉林省、黑龙江省、上海市、江苏省、浙江省、安徽省、福建省、江西省、山东省、河南省、湖北省、湖南省、广东省、广西壮族自治区、海南省、重庆市、四川省、贵州省、云南省、西藏自治区、陕西省、甘肃省、青海省、宁夏回族自治区、新疆维吾尔自治区。",
          time: "2026/1/30-2028/4/13",
          flow: "http://property.pingan.com/kehufuwu/baodanchaxun.shtml",
          tel: "95511",
          evaluate:
            "https://property.pingan.com/gongkaixinxipilu/changfunenglixinxipilubaogao.shtml",
          no: "易才宏业保险经纪有限公司在保险公司的授权下，严格依据《保险中介许可证》的业务范围为客户提供保险经纪服务的同时代理销售保险公司授权的保险产品",
          company: "https://property.pingan.com/index.shtml",
        },
      ],
      itemsNew: [
         {
          name: "众安在线财产保险股份有限公司",
          title: '易才灵工保',
          no: "新就业形态用工责任保险条款（互联网 2026 版 A 款）",
          serial_num: ["C00017930912026012744303"],
          terms: "https://static.zhongan.com/upload/online/material/1769757645474.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才灵工保',
          no: "附加自费药保险条款（互联网 2026 版 A 款）",
          serial_num: ["C00017930922026012744313"],
          terms: "https://static.zhongan.com/upload/online/material/1769757469954.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才灵工保',
          no: "附加第三者责任保险条款（互联网 2026 版 A 款）",
          serial_num: ["C00017930922026012844543"],
          terms: "https://static.zhongan.com/upload/online/material/1769757814275.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才灵工保',
          no: "附加伤残等级赔偿限额比例调整保险条款（互联网 2026 版 C 款）",
          serial_num: ["C00017930922026012844693"],
          terms: "https://static.zhongan.com/upload/online/material/1769757645474.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才灵工保',
          no: "附加伤残等级赔偿限额比例调整保险条款（互联网 2026 版 A 款）",
          serial_num: ["C00017930922026012844563"],
          terms: "https://static.zhongan.com/upload/online/material/1769757580020.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才灵工保',
          no: "附加医疗项目责任保险条款（互联网 2026 版 B款）",
          serial_num: ["C00017930922026041404373"],
          terms: "https://static.zhongan.com/upload/online/material/1776331218231.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才灵工保',
          no: "附加及时报案条款（互联网版）",
          serial_num: ["C00017931922022012902453"],
          terms: "http://static.zhongan.com/upload/online/material/1644917778290.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才灵工保',
          no: "附加保险事故限制特约保险条款（互联网 2022 版）",
          serial_num: ["C00017931922022062915531"],
          terms: "http://static.zhongan.com/upload/online/material/1657270705958.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才灵工保',
          no: "附加高处作业除外保险条款（互联网 2026 版 A 款）",
          serial_num: ["C00017931922026012844883"],
          terms: "https://static.zhongan.com/upload/online/material/1769757298480.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "附加交叉责任保险（互联网版）",
          serial_num: ["C00017930922022032424081"],
          terms: "https://static.zhongan.com/upload/online/material/1649319777687.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "附加建筑物改动责任保险（互联网版）",
          serial_num: ["C00017930922022040641453"],
          terms: "https://static.zhongan.com/upload/online/material/1650427019878.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "附加被保险人保险（互联网版）",
          serial_num: ["C00017930922022040641493"],
          terms: "https://static.zhongan.com/upload/online/material/1650427113578.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "附加急救费用责任保险（互联网版）",
          serial_num: ["C00017930922022072603433"],
          terms: "https://static.zhongan.com/upload/online/material/1659324845114.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "公众责任保险（C款）（互联网版）",
          serial_num: ["C00017930912022072241513"],
          terms: "https://static.zhongan.com/upload/online/material/1659324350655.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "附加火灾、爆炸、烟熏、水损责任保险（互联网2025版）",
          serial_num: ["C00017930922025082705563"],
          terms: "https://static.zhongan.com/upload/online/material/1756984552303.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "附加水箱、水管爆裂扩展保险（互联网2026版）",
          serial_num: ["C00017930622025112572963"],
          terms: "https://static.zhongan.com/upload/online/material/1764152703895.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "附加广告及装饰装置责任",
          serial_num: ["H00017930922016120655771"],
          terms: "http://static.zhongan.com/upload/online/bxtk/1449135107861_公众责任保险附加险条款（11个整理版）.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "附加人身侵害责任保险（互联网版）",
          serial_num: ["C00017930922022040641473"],
          terms: "https://static.zhongan.com/upload/online/material/1650427080567.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "附加食品、饮料责任保险（B款）（互联网版）",
          serial_num: ["C00017930922022080515003"],
          terms: "https://static.zhongan.com/upload/online/material/1660199776896.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "附加盗窃、抢劫扩展保险（互联网2026版A款）",
          serial_num: ["C00017930622025112150223"],
          terms: "https://static.zhongan.com/upload/online/material/1763290161247.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "众安在线财产保险股份有限公司",
          title: '易才店店保（餐饮行业）',
          no: "财产基本险（互联网2026版A款）",
          serial_num: ["C00017930612025112837543"],
          terms: "https://static.zhongan.com/upload/online/material/1764589116319.pdf",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401",
        },
        {
          name: "中国平安财产保险股份有限公司",
          title: '平安行境内旅意TJ（互联网）',
          no: "平安产险附加猝死保障保险（互联网版）",
          serial_num: ["注册号：C00001731922022081720843"],
          terms: "http://iobs.pingan.com.cn/download/icore-aops-base-dmz-prd/ICORE_CPS-1760531469711-E78DCA59D0C24852935ECC1454E14CF4-43595057",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401"
        },
        {
          name: "中国平安财产保险股份有限公司",
          title: '平安行境内旅意TJ（互联网）',
          no: "平安产险附加定残标准、伤残赔付等级和给付比例约定保险",
          serial_num: ["注册号：C00001732322020112709461"],
          terms: "https://iobs.pingan.com.cn/download/icore-aops-base-dmz-prd/ICORE_CPS-1760531046893-0E01D10B637D433F94BB44E078D86592-4607612",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401"
        },
        {
          name: "中国平安财产保险股份有限公司",
          title: '平安行境内旅意TJ（互联网）',
          no: "平安产险附加急性病医疗保险（互联网版）",
          serial_num: ["注册号：C00001732522022101051173"],
          terms: "https://iobs.pingan.com.cn/download/icore-aops-base-dmz-prd/ICORE_CPS-1760531595301-B302DF44505B42C59CF96F2C21781BD1-99589769",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401"
        },
        {
          name: "中国平安财产保险股份有限公司",
          title: '平安行境内旅意TJ（互联网）',
          no: "平安产险附加意外伤害住院津贴保险（互联网版）",
          serial_num: ["注册号：C00001732522022072500061"],
          terms: "https://iobs.pingan.com.cn/download/icore-aops-base-dmz-prd/ICORE_CPS-1760531430963-A28888C9F52F40E8BF83CB5FA12D16A8-55971558",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401"
        },
        {
          name: "中国平安财产保险股份有限公司",
          title: '平安行境内旅意TJ（互联网）',
          no: "平安产险旅行意外伤害保险（互联网版）（2025 版）",
          serial_num: ["注册号：C00001732312025112831423"],
          terms: "https://iobs.pingan.com.cn/download/icore-aops-base-dmz-prd/ICORE_CPS-1764430296650-A321E47E9FB54365AE264B68DF337F76-35237716",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401"
        },
        {
          name: "中国平安财产保险股份有限公司",
          title: '平安行境内旅意TJ（互联网）',
          no: "平安产险意外险附加突发疾病身故保险（互联网版）（2025 版）",
          serial_num: ["注册号：C00001732322025090207033"],
          terms: "https://iobs.pingan.com.cn/download/icore-aops-base-dmz-prd/ICORE_CPS-1760533828106-EA68163AEBE240C990BED6C340D6B9CA-20417292",
          link: "http://icidp.iachina.cn/?columnid_url=201509301401"
        },
      ],
    };
  },
  computed: {
    bannerHeight() {
      return this.$vuetify.breakpoint.name === "xs" ? 150 : 377;
    },
    // 计算保险公司列的 rowspan
    companyRowspanMap() {
      const map = {};
      const items = this.itemsNew || [];
      
      items.forEach((item, index) => {
        const company = item.name;
        if (!map[company]) {
          map[company] = { firstIndex: index, count: 0 };
        }
        map[company].count++;
      });
      
      return map;
    },
    
    // 计算产品名称列的 rowspan（按保险公司+产品名称分组）
    titleRowspanMap() {
      const map = {};
      const items = this.itemsNew || [];
      
      items.forEach((item, index) => {
        const key = `${item.name}-${item.title}`;
        if (!map[key]) {
          map[key] = { firstIndex: index, count: 0 };
        }
        map[key].count++;
      });
      
      return map;
    }
  },
  mounted() {
    // this.getInformationProduct();
    console.log(this.$route.query.tab);
    this.chooseId =
      this.$route.query.tab > 0 ? Number(this.$route.query.tab) : 0;
  },
  methods: {
    choose(index) {
      this.chooseId = index;
      if (index == 4) {
        this.showId = 0;
      }
    },
    getInformationProduct() {
      this.$axios.get("/json/productlist_xxpl.json").then((list) => {
        list.map((data) => {
          let col = {
            name: data.productName,
          };
          let company = [];
          let serial_num = [];
          let terms = [];
          data.recordBoList.map((item) => {
            company.push(item.recordName);
            serial_num.push(item.recordNumber);
            let terms_info = {
              name: item.clauseName,
              url: item.clauseUrl,
            };
            terms.push(terms_info);
          });
          col.company = company;
          col.serial_num = serial_num;
          col.terms = terms;
          this.itemsNew.push(col);
        });
      });
    },
  },
};
</script>

<style lang="scss">
.p-information {
  background-color: #ffffff;

  .navigation {
    display: flex;
    color: #666666;
    font-size: 18px;
    border-bottom: 1px solid #e4e4e4;
    justify-content: center;
    align-items: center;
    // li{
    //   padding-bottom:23px ;
    // }
    // li:nth-child(2){
    //   margin: 0 135px 0 181px;
    // }
    .pitchLi {
      color: #dd122b;
      border-bottom: 4px solid #dd122b;
    }
    .item_tab {
      font-size: 18px;
    }
    // .item_tab:nth-child(3) {
    //   /*margin: 0 135px 0 181px;*/
    //   margin: 0 15px 0 30px;
    // }
    .item_tab {
      /*margin: 0 135px 0 181px;*/
      margin: 0 10px;
    }
  }
  h1,
  h2 {
    font-weight: 400;
  }
  .section {
    max-width: 1000px;
    margin: 2em auto 0;
    padding: 15px;
    h2 {
      text-align: center;
      font-size: 36px;
    }
  }
  .a_section {
    max-width: 65%;
  }
  .b_section {
    max-width: 100%;
  }
  .licence-img {
    width: 100%;
    max-width: 400px;
  }
  .insurance-licence-img {
    margin-top: 18px;
  }
  .table {
    table {
      min-width: 1000px;
      tr:hover {
        background-color: inherit !important;
      }
    }
    thead {
      background-color: #fff6f7;
      th {
        font-size: 1em;
        font-weight: 600;
        color: #222;
      }
    }
    th,
    td {
      border: 1px solid #dadada;
    }
    .tb-row-caption {
      color: $font-color3;
    }
    .td-text {
      padding: 1.5em 1em;
    }
  }
  .contact {
    text-align: center;
    margin-bottom: 4em;
    p {
      margin: 0.5em 0;
    }
  }
}
@media screen and (max-width: 1000px) {
  .p-information {
    .navigation {
      .item_tab {
        font-size: 16px;
      }
      .item_tab {
        margin: 0 10px 0 10px;
      }
    }
    .mb-4 {
      font-size: 28px !important;
    }
    .a_section {
      max-width: 100%;
    }
    .b_section {
      max-width: 100%;
    }
  }
}
</style>
<style scoped>
</style>
